<template>
  <div ref="alert-parent">
    <div>
      <b-tooltip
        :ref="'tooltip'"
        custom-class="custom-tooltip"
        :show="true"
        :target="id"
        :placement="placement"
        variant="light"
        @hidden="destroyTooltip"
      >
        <appTimePicker :minute-event="event" @change="onChange($event, event), (show = !show)" />
      </b-tooltip>
    </div>
  </div>
</template>
<script>
export default {
  components: {
    appTimePicker: () => import("@/components/fields/TimePicker"),
  },
  props: {
    event: {
      type: Object,
      default: () => {
        return {};
      },
    },
    id: {
      type: String,
      default: "",
    },
    placement: {
      type: String,
      defaul: "top",
    },
  },
  data() {
    return {
      show: true,
    };
  },
  mounted() {
    this.$refs.tooltip.$emit("click");
  },
  methods: {
    destroyTooltip($event) {
      this.$emit("destroy-tooltip", $event);
    },
    onChange($event, event) {
      this.$emit("change", { newDate: $event, minuteEvent: event });
    },
    toUtc(date) {
      /*
       * This function will make sure that old meeting data that has no timezone will have UTC
       */
      if (date) {
        return this.$moment.parseZone(date).utcOffset(0, true).format("YYYY-MM-DDTHH:mm:ssZ");
      } else {
        return date;
      }
    },
  },
};
</script>
